import 'tailwindcss/index.css';
import 'react-toastify/dist/ReactToastify.css';

import { lazy, Suspense, Component, type ErrorInfo, type ReactNode } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Layout from './presentation/components/Layout';
import { ROUTES } from './presentation/constants/routes';
import useGetGlobalData from './presentation/hooks/useGetGlobalData';

const LivestreamConfirmOrder = lazy(() => import('./presentation/pages/livestream-confirm-order'));
const MissingLivestreamLink = lazy(() => import('./presentation/pages/missing-livestream-link'));

class AppErrorBoundary extends Component<{ children: ReactNode }, { errorMessage: string }> {
    constructor(props: { children: ReactNode }) {
        super(props);
        this.state = { errorMessage: '' };
    }

    static getDerivedStateFromError(error: Error) {
        return { errorMessage: error?.message || 'Unknown render error' };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('App render error:', error, errorInfo);
    }

    render() {
        if (this.state.errorMessage) {
            return (
                <section className='mx-auto max-w-md p-4'>
                    <p className='text-[1rem] text-red-600'>Ứng dụng gặp lỗi khi hiển thị.</p>
                    <p className='mt-2 text-sm text-neutral-600'>{this.state.errorMessage}</p>
                </section>
            );
        }

        return this.props.children;
    }
}

function App() {
    useGetGlobalData();

    return (
        <AppErrorBoundary>
            <ToastContainer />
            <Router>
                <Layout>
                    <Suspense fallback={<p className='p-4 text-center text-[1rem]'>Đang tải dữ liệu ...</p>}>
                        <Routes>
                            <Route
                                path={ROUTES.root.url}
                                element={<MissingLivestreamLink />}
                            />
                            <Route
                                path={ROUTES.confirmLivestream.url}
                                element={<LivestreamConfirmOrder />}
                            />
                            <Route
                                path={ROUTES.order.url}
                                element={<LivestreamConfirmOrder />}
                            />
                        </Routes>
                    </Suspense>
                </Layout>
            </Router>
        </AppErrorBoundary>
    );
}

export default App;
